import type { Assessment } from "../types/assessment.js";
import { isAssessmentStatusUnderWay } from "./isAssessmentStatusUnderWay.js";

/**
 * Whether a practitioner who may read what an assessment says may also
 * download it as a PDF: only where their organisation lets practitioners
 * download PDFs, and only once it is finished, approved where it is
 * definitive and completed where it is not. An assessment still being worked
 * on, or waiting for approval, is never offered as a PDF.
 *
 * Reading what it says is `mayReadAssessmentContents`, asked beside this.
 * One statement for the server's gate and the page's offer, so a page never
 * offers a download the server refuses.
 */
export const mayPractitionerDownloadAssessmentPdf = ({
  assessment,
  practitionersMayDownloadPdfs,
}: {
  assessment: Pick<Assessment, "status">;
  /** The organisation's "Practitioners can download PDFs" setting. */
  practitionersMayDownloadPdfs: boolean;
}): boolean =>
  practitionersMayDownloadPdfs &&
  !isAssessmentStatusUnderWay(assessment.status);
